import React from 'react'
import Grid from '@material-ui/core/Grid'
import Cryo from './Cryo'
import Bulk from './Bulk'
import Pack from './Pack'
import Gasmatic from './Gasmatic'
import Content from 'components/shared/Content'
import * as utils from 'utils/common'
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import { MBTYPES, SBTYPES, TRACKERTYPES } from 'utils/constants'
import CoreInput from '@material-ui/core/Input'

interface Props {
  canSave: boolean,
  device: any,
  onSave: () => void,
  onCancel: () => void,
  onInputChange: (
    prop: string
  ) => (
      evt:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
        | React.ChangeEvent<HTMLTextAreaElement>
    ) => void

  onDateChange: (
    prop: string
  ) => (
      evt: React.ChangeEvent<HTMLInputElement>
    ) => void
  mbSelectDate: string,
  altSelectDate: string
}

const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

const EditMode = ({
  canSave,
  device,
  onSave,
  onCancel,
  onInputChange,
  onDateChange,
  mbSelectDate,
  altSelectDate
}: Props) => {
  const sensorData = device.info.data
  if (!sensorData) {
    return null
  }

  return (
    <Grid container direction="column">
      {(device.type == 'pack') ? (<Grid item>
        {(device.dporhe != undefined && device.dporhe == 'DP') ? <Content style={style} label="Type" value='DP' /> : <Content style={style} label="Type" value='Pressure Transducer' />}
      </Grid>) :
        (<Grid item>
          {(device.dporhe != undefined && device.dporhe == 'DP') ? <Content style={style} label="Type" value='DP' /> : <Content style={style} label="Type" value={utils.toTitleCase(sensorData.type)} />}
        </Grid>)
      }
      <Grid item>
        <Content style={style} label="Main Battery" value={sensorData.mbat != undefined && `${sensorData.mbat.toFixed(2)} v`} />
      </Grid>
      {(device.type !== 'pack') && (<Grid item>
        <TextField
          id="mbDate"
          label="MB Date"
          type="date"
          name='selectdateMb'
          onChange={onDateChange('mbDate')}
          value={mbSelectDate}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>)}
      {(device.type !== 'pack') && (<Grid item>
        <Box my={1}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="type">MB Type</InputLabel>
            <Select
              value={device.mbType}
              onChange={onInputChange('mbType')}
              input={<CoreInput name="type" id="type" />}
            >
              {MBTYPES.map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  <Typography variant="body1">{label}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>)}
      {!TRACKERTYPES.includes(sensorData.type.toString().toLowerCase()) &&
        (<Grid container direction="column">
          {/* <Grid item>
          {(sensorData.type === 'pack' || sensorData.type === 'manifold') ? <Content style={style} label="Secondary Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} %`} /> :
              <Content style={style} label="Secondary Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} v`} />}
          </Grid> */}

          {(device.type !== 'pack') && (<Grid item>
            {(sensorData.type === 'manifold') ? <Content style={style} label="Secondary Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} %`} /> :
              <Content style={style} label="Secondary Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} v`} />}
          </Grid>)}
          {(device.type === 'pack') && (<Grid item>
            <Content style={style} label="PT Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} %`} />
          </Grid>)}
          {(device.type !== 'pack') && (<Grid item>
            <TextField
              id="altDate"
              label="SB Date"
              type="date"
              name='selectdateAlt'
              onChange={onDateChange('altDate')}
              value={altSelectDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>)}
          {(device.type !== 'pack') && (<Grid item>
            <Box my={1}>
              <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor="type">SB Type</InputLabel>
                <Select
                  value={device.sbType}
                  onChange={onInputChange('sbType')}
                  input={<CoreInput name="type" id="type" />}
                >
                  {SBTYPES.map(({ key, label }) => (
                    <MenuItem key={key} value={key}>
                      <Typography variant="body1">{label}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>)}
          {sensorData.type === 'cryo' && <Cryo sensor={{ ...sensorData, dporhe: device.dporhe, settings: device.settings }} />}
          {sensorData.type === 'gasmatic' && <Gasmatic sensor={{ ...sensorData, settings: device.settings }} />}
          {sensorData.type === 'bulk' && <Bulk sensor={{ ...sensorData }} />}
          {device.type === 'pack' && <Pack sensor={{ ...sensorData }} />}
          <Grid item>
            <Content style={style} label="RSSI" value={device.sensor != undefined && device.sensor.rssi} />
          </Grid>
          <Grid item>
            <Content style={style} label="Received" value={device.sensor != undefined && utils.dateString(device.sensor.datetime, true)} />
          </Grid>
        </Grid>)
      }
      <div>
        <Box my={2}>
          <Grid container item justify="space-evenly">
            <Grid item xs={5}>
              <Button fullWidth color="secondary" variant="contained" onClick={onCancel}>
                <Typography variant="h4" color="primary">
                  Cancel
            </Typography>
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button fullWidth variant="contained" onClick={onSave} disabled={!canSave}>
                <Typography variant="h4" color="primary">
                  Save
            </Typography>
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>
    </Grid>
  )
}
export default EditMode
